<header
    class="bg-shs-gray-5 min-h-[70px] px-4 py-2 w-full flex flex-col sm:flex-row justify-between sm:items-center fixed top-0 z-50 gap-2 overflow-hidden"
>
    <div class="flex items-center gap-2 sm:gap-4 min-w-0 flex-1">
        <img src="{{ logo }}" class="h-8 sm:h-10 md:h-12 lg:h-[60px] flex-shrink-0" alt="Siemens Healthineers" />

        <h1
            class="text-shs-white-1 text-xs sm:text-sm md:text-base lg:text-lg font-bold font-sh-bree leading-tight break-words"
        >
            Customer Order Discrepancy v2
        </h1>
    </div>

    <div class="flex items-center gap-2 self-end sm:self-auto flex-shrink-0 max-w-full overflow-hidden">
        <app-user></app-user>
    </div>
</header>
